import * as redux from 'redux';
import thunk from 'redux-thunk';
//import createSagaMiddleware from 'redux-saga';

//import mySaga from '../sagas/sagas';

import authReducer from '../reducers/authReducer';
import formReducer from '../reducers/formReducer';
//import basicInfoReducer from '../reducers/basicInfoReducer';
//import otherInfoReducer from '../reducers/otherInfoReducer';
//import professionalInfoReducer from '../reducers/professionalInfoReducer';
//import educationInfoReducer from '../reducers/educationInfoReducer';
import appInfoReducer from '../reducers/appInfoReducer';
import applicationReducer from '../reducers/applicationReducer';

export const configure = (initialState = {}, context = {}) => {
  //const sagaMiddleware = createSagaMiddleware();

  const reducer = redux.combineReducers({
    appInfo: appInfoReducer,
    //educationInfo: educationInfoReducer,
    //otherInfo: otherInfoReducer,
    //professionalInfo: professionalInfoReducer,
    //basicInfo: basicInfoReducer,
    auth: authReducer,
    form: formReducer,
    application: applicationReducer
  });

  const store = redux.createStore(
    reducer,
    initialState,
    redux.compose(
      redux.applyMiddleware(thunk),
      //redux.applyMiddleware(sagaMiddleware),
      window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__() : f => f
    )
  );

  //sagaMiddleware.run(mySaga, context);

  return store;
};